import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface VehicleProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function Vehicle({ color = RoutalPalette.secondary60, style = {} }: VehicleProps) {
  return (
    <SvgIcon width="12" height="12" viewBox="0 0 12 12" style={{ height: `16px`, width: `16px`, ...style }}>
      <g>
        <path
          fill={color}
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9.93,3.05c-.22-.44-.68-.71-1.18-.71H1.55c-.49,0-.88.39-.88.86v4.74c0,.24.2.43.44.43h.53c0-.71.59-1.29,1.32-1.29s1.32.58,1.32,1.29h2.65c0-.71.59-1.29,1.32-1.29s1.32.58,1.32,1.29h1.32c.24,0,.44-.19.44-.43v-2.16l-1.4-2.73Z"
        />
        <path
          fill="#fafafa"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M2.96,9.66c.73,0,1.32-.58,1.32-1.29s-.59-1.29-1.32-1.29-1.32.58-1.32,1.29.59,1.29,1.32,1.29Z"
        />
        <path
          fill="#fafafa"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M8.25,9.66c.73,0,1.32-.58,1.32-1.29s-.59-1.29-1.32-1.29-1.32.58-1.32,1.29.59,1.29,1.32,1.29Z"
        />
        <path fill="#fafafa" strokeWidth="0px" d="M.97,3.62c0-.54.43-.97.97-.97h5.05v2.4H.97v-1.43Z" />
        <path
          fill="#fafafa"
          strokeWidth="0px"
          d="M7.57,2.64h1.03c.82,0,.98.39,1.23.87.38.75.58,1.14.78,1.54h-3.05v-2.41Z"
        />
      </g>
    </SvgIcon>
  );
}
